<div class="modal-header" *transloco="let t; prefix: 'compliance.overview.editPeriodicModal'">
  <h5 class="modal-title">{{ t('title') }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body" *transloco="let t; prefix: 'compliance.overview.editPeriodicModal'">
  <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label>{{ t('assetName') }}</label>
      <input type="text" class="form-control" formControlName="assetName" readonly>
    </div>

    <div class="form-group">
      <label>{{ t('complianceStandards') }}</label>
      <input type="text" class="form-control" formControlName="complianceStandard" readonly>
    </div>

    <div class="form-row">
      <div class="form-group half-width">
        <label>{{ t('workshop') }}</label>

        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle">{{ workshopLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @if (isLoadingWorkshops) {
                <div class="dropdown-loading">
                  <span class="spinner-border spinner-border-sm"></span>
                  <span>{{ t('loadingWorkshops') }}</span>
                </div>
              } @else if (workshops.length === 0) {
                <div class="dropdown-loading">
                  <span>{{ t('noWorkshopsFound') }}</span>
                </div>
              } @else {
                @for (workshop of workshops; track workshop.id) {
                  <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onWorkshopSelect(workshop, $event)">
                    {{ workshop.name }}
                  </button>
                }
              }
            </div>
          </div>
        </div>

      </div>

      <div class="form-group half-width">
        <label>{{ t('complianceFrequency') }} <span class="required">*</span></label>

        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle">{{ frequencyLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @if (isLoadingFrequencies) {
                <div class="dropdown-loading">
                  <span class="spinner-border spinner-border-sm"></span>
                  <span>{{ t('loadingFrequencies') }}</span>
                </div>
              } @else if (frequencies.length === 0) {
                <div class="dropdown-loading">
                  <span>{{ t('noFrequenciesFound') }}</span>
                </div>
              } @else {
                @for (frequency of frequencies; track frequency.id) {
                  <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onFrequencySelect(frequency, $event)">
                    {{ frequency.name | lookupLabel:'compliance.shared.frequencies' }}
                  </button>
                }
              }
            </div>
          </div>
        </div>

        @if (editForm.get('frequencyId')?.invalid && editForm.get('frequencyId')?.touched) {
          <div class="error-message">{{ t('frequencyRequired') }}</div>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="cancel-btn" (click)="onCancel()" [disabled]="isLoading">{{ 'common.cancel' | transloco }}</button>

      <button type="submit" class="add-btn" [disabled]="isLoading || editForm.invalid || !hasChanges">
        @if (isLoading) {
          <span class="spinner-border spinner-border-sm"></span>
        }
        @if (!isLoading) {
          <span>{{ 'common.saveChanges' | transloco }}</span>
        }
      </button>
    </div>
  </form>
</div>
